<form
  *ngIf="{
    currentUser: currentUser$ | async,
    violations: violations$ | async
  } as STATE"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="resource-form"
>
  <div class="input-group">
    <article class="form-control">
      <mat-label>Entrer l'adresse électronique</mat-label>
      <mat-form-field color="primary" appearance="outline">
        <input
          formControlName="email"
          matInput
          id="email"
          type="email"
          [value]="STATE.currentUser?.email"
          [disabled]="true"
          trim="blur"
        />
      </mat-form-field>
    </article>
  </div>
  <div class="input-group">
    <article>
      <mat-label>Nom</mat-label>
      <mat-form-field color="primary" appearance="outline">
        <input formControlName="firstName" matInput />
        <mat-error
          *ngIf="
            formControls.firstName.touched &&
            formControls.firstName.hasError('required')
          "
        >
          <ng-container *ngTemplateOutlet="requiredError"></ng-container>
        </mat-error>

        <mat-error
          *ngIf="form.get('firstName')?.getError('httpError') as error"
          [innerHtml]="error"
        ></mat-error>
      </mat-form-field>
    </article>
    <article>
      <mat-label>Prénom(s)</mat-label>
      <mat-form-field color="primary" appearance="outline">
        <input formControlName="lastName" matInput />
        <mat-error
          *ngIf="
            formControls.lastName.touched &&
            formControls.lastName.hasError('required')
          "
        >
          <ng-container *ngTemplateOutlet="requiredError"></ng-container>
        </mat-error>
        <mat-error
          *ngIf="form.get('lastName')?.getError('httpError') as error"
          [innerHtml]="error"
        ></mat-error>
      </mat-form-field>
    </article>
  </div>
  <article>
    <mat-label>Tel</mat-label>
    <mat-form-field color="primary" appearance="outline">
      <input
        #phoneNumberInput
        formControlName="phoneNumber"
        matInput
        type="tel"
      />
      <mat-error *ngIf="formControls.phoneNumber.hasError('required')">
        <ng-container *ngTemplateOutlet="requiredError"></ng-container>
      </mat-error>
      <mat-error
        *ngIf="form.get('phoneNumber')?.getError('httpError') as error"
        [innerHtml]="error"
      ></mat-error>
    </mat-form-field>
  </article>

  <div>
    <button
      type="submit"
      [attr.disabled]="isLoading()"
      [disabled]="isLoading() || form.invalid || !form.dirty"
      button
    >
      {{ isLoading() ? 'Chargement...' : 'Mettre à jour' }}
    </button>
  </div>
</form>

<ng-template #requiredError> Ce champ est requis </ng-template>
